// Generated by ReScript, PLEASE EDIT WITH CARE

import * as UserRoles from "../../types/workspace/UserRoles.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as CookieUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/CookieUtils.bs.js";

function fetchUserRoles(param) {
  var user_roles_cookie = CookieUtils$Catalyst.getCookie("user_roles");
  return DeccoUtils$Catalyst.resolveResult(UserRoles.t_decode(user_roles_cookie), "WorkspaceRepo.re");
}

var WorkSpaceRepo = {
  fetchUserRoles: fetchUserRoles
};

export {
  WorkSpaceRepo ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
